import { FC, useEffect, useState } from 'react'
import { Box } from '../atoms/Grid'
import ProductsSlider, {
  ProductSlide
} from '@/components/organisms/productsSlider'
import Link from 'next/link'
import styled from 'styled-components'
import { Tiny2 } from '../atoms/typography'
import { Category } from '@/network/graphql.g'
import { useRouter } from 'next/router'
import { useMhub } from '@/providers/mhubProvider'

type TopCategoriesProps = {
  carouselTopCategories: Category[]
}

const TopCategoriesSlider: FC<TopCategoriesProps> = ({
  carouselTopCategories
}) => {
  const router = useRouter()
  const [activeCategory, setActiveCategory] = useState(
    router.asPath.split('?')[0]
  )
  const [swiper, setSwiper] = useState(null)

  useEffect(() => {
    if (swiper) {
      const index = carouselTopCategories.findIndex(
        (category) => category.url === activeCategory
      )
      swiper.slideTo(index, 0)
    }
  }, [activeCategory, carouselTopCategories, swiper])

  const handleButtonClick = (categoryUrl: string) => {
    setActiveCategory(categoryUrl)
  }

  const { pushMobileCategoriesQuickFilterAdd } = useMhub()

  const handleClick = (mobileCategory) => {
    handleButtonClick(mobileCategory?.url)
    pushMobileCategoriesQuickFilterAdd(
      mobileCategory?.id,
      mobileCategory?.title
    )
  }

  return (
    <Box mt="10px">
      <StyledProductsSlider
        showArrows={false}
        spaceBetween={10}
        onSwiper={(swiperInstance) => setSwiper(swiperInstance)}
        centeredSlides={true}
        centeredSlidesBounds={true}
      >
        {carouselTopCategories?.map((mobileCategory) => {
          return (
            <ProductSlide key={mobileCategory?.id}>
              <Link href={mobileCategory?.url}>
                <MobileCategoryButton
                  onClick={() => handleClick(mobileCategory)}
                  isClicked={activeCategory === mobileCategory.url}
                >
                  <StyledTiny2>{mobileCategory?.title}</StyledTiny2>
                </MobileCategoryButton>
              </Link>
            </ProductSlide>
          )
        })}
      </StyledProductsSlider>
    </Box>
  )
}

export default TopCategoriesSlider

const StyledProductsSlider = styled(ProductsSlider)`
  .swiper-slide {
    width: max-content;
  }
`

const MobileCategoryButton = styled.button`
  color: ${(props) => props.theme.colors.onBackground};
  height: 36px;
  text-align: center;
  width: max-content;
  border-radius: 2px;
  padding: 4px 10px;
  background-color: ${(props) =>
    props.isClicked
      ? props.theme.colors.background
      : props.theme.colors.mobileBackground};
  border: 1px solid
    ${(props) =>
      props.isClicked
        ? props.theme.colors.onBackground
        : props.theme.colors.mobileBackground};
  cursor: pointer;
`

const StyledTiny2 = styled(Tiny2)`
  font-weight: 400;
  margin: 0;
  color: ${(props) => props.theme.colors.onBackground};
`
